import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  key: 0,
  class: "dialog-plant-create__grid--even"
}
const _hoisted_5 = {
  key: 0,
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_6 = {
  class: "p-field",
  style: {"margin-right":"10px","margin-left":"10px"}
}
const _hoisted_7 = { style: {"margin-right":"10px","margin-left":"10px"} }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = {
  class: "p-field-label mt-1",
  for: "riserName"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-field-label mb-3" }
const _hoisted_12 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_13 = { style: {"margin-right":"10px","margin-left":"10px"} }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = {
  class: "p-field-label mt-1",
  for: "interfaceAddr"
}
const _hoisted_16 = {
  for: "interfaceAddr",
  class: "fs-13 label-error"
}
const _hoisted_17 = { class: "p-field my-4" }
const _hoisted_18 = { class: "p-field-label mb-2" }
const _hoisted_19 = { class: "card__head d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center ml-2" }
const _hoisted_21 = { class: "bt-icon my-auto bt-icon--m text-gray" }
const _hoisted_22 = { class: "ml-3" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { class: "card__head d-flex align-items-center" }
const _hoisted_25 = { class: "d-flex align-items-center ml-2" }
const _hoisted_26 = { class: "bt-icon my-auto bt-icon--m text-gray" }
const _hoisted_27 = { class: "ml-3" }
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = {
  key: 1,
  class: "separator mt-3 mb-4",
  style: {"background-color":"currentColor","opacity":"0.25"}
}
const _hoisted_30 = {
  key: 1,
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_31 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Card = _resolveComponent("Card")
  const _component_GateConfigComponent = _resolveComponent("GateConfigComponent")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.step == 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.currentRiser)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.Riser")+ " " + _ctx.currentRiser.index), 1)
                  ]),
                  _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.Name")), 1),
                          _createVNode(_component_InputText, {
                            id: "riserName",
                            style: {"width":"60%"},
                            modelValue: _ctx.currentRiser.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentRiser.name = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_10, [
                          _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterfaceModeUpper")), 1),
                          _createVNode(_component_ListItemRadio, {
                            label: _ctx.$t('AppResourceEP.Mode5IndependentRiser'),
                            inputId: "InterfaceComboMode_Mode5IndipendentRiser",
                            modelValue: _ctx.InterfaceComboMode,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.InterfaceComboMode = $event)),
                            name: "riserInterfaceMode",
                            value: _ctx.RiserInterfaceModeCombo.Mode5IndipendentRiser
                          }, null, 8, ["label", "modelValue", "value"]),
                          _createVNode(_component_ListItemRadio, {
                            label: _ctx.$t('AppResourceEP.Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion'),
                            inputId: "InterfaceComboMode_Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion",
                            modelValue: _ctx.InterfaceComboMode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.InterfaceComboMode = $event)),
                            name: "riserInterfaceMode",
                            value: _ctx.RiserInterfaceModeCombo.Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion
                          }, null, 8, ["label", "modelValue", "value"]),
                          _createVNode(_component_ListItemRadio, {
                            label: _ctx.$t('AppResourceEP.Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion'),
                            inputId: "InterfaceComboMode_Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion",
                            modelValue: _ctx.InterfaceComboMode,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.InterfaceComboMode = $event)),
                            name: "riserInterfaceMode",
                            value: _ctx.RiserInterfaceModeCombo.Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion,
                            last: ""
                          }, null, 8, ["label", "modelValue", "value"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_13, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentRiserInterfaces, (riserInterface, key) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: key }, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("h5", null, _toDisplayString(_ctx.getInterfaceDescription(riserInterface.mode, key, _ctx.currentRiserInterfaces.length)), 1),
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterfaceAddressMUpper")), 1),
                          (key === 0)
                            ? (_openBlock(), _createBlock(_component_InputText, {
                                key: 0,
                                id: "interfaceAddr",
                                class: {'input-error': _ctx.anyScsError},
                                type: "number",
                                min: _ctx.MIN_SCS_ADDRESS_INTERFACE,
                                max: _ctx.MAX_SCS_ADDRESS_INTERFACE,
                                style: {"width":"60%"},
                                modelValue: _ctx.mainScsAddress,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mainScsAddress = $event))
                              }, null, 8, ["class", "min", "max", "modelValue"]))
                            : (_openBlock(), _createBlock(_component_InputText, {
                                key: 1,
                                disabled: "",
                                id: "interfaceAddr",
                                class: {'input-error': _ctx.addrNotValid[key]},
                                type: "number",
                                style: {"width":"60%"},
                                modelValue: riserInterface.scsAddress,
                                "onUpdate:modelValue": ($event: any) => (riserInterface.scsAddress = $event)
                              }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])),
                          _createVNode("div", null, [
                            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.invalidAddrReason[key]), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfApartmentsUpper")) + ": ", 1),
                          _createVNode(_component_Dropdown, {
                            class: "w-100",
                            modelValue: riserInterface.numberOfApartments,
                            "onUpdate:modelValue": ($event: any) => (riserInterface.numberOfApartments = $event),
                            options: _ctx.noAppartmentOptions(),
                            optionLabel: "label",
                            optionValue: "value"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        (key === 0)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_Card, { class: "card--slim my-4" }, {
                                content: _withCtx(() => [
                                  _createVNode("div", _hoisted_19, [
                                    _createVNode("div", _hoisted_20, [
                                      _createVNode("span", _hoisted_21, [
                                        _createVNode(_component_InlineSvgScoped, {
                                          src: 
                                                            require(`@/assets/images/entrancePlants/icon-gate.svg`)
                                                        ,
                                          "aria-label": "icon-gate"
                                        }, null, 8, ["src"])
                                      ]),
                                      _createVNode("div", _hoisted_22, [
                                        _createVNode("h6", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.Gates")), 1)
                                      ])
                                    ]),
                                    (riserInterface.gatesCount !== undefined)
                                      ? (_openBlock(), _createBlock(_component_NumberButtons, {
                                          key: 0,
                                          class: "ml-auto",
                                          modelValue: riserInterface.gatesCount,
                                          "min-value": 0,
                                          "max-value": 95,
                                          onIncrement: ($event: any) => (riserInterface.gatesCount++),
                                          onDecrement: ($event: any) => (riserInterface.gatesCount--)
                                        }, null, 8, ["modelValue", "onIncrement", "onDecrement"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_Card, { class: "card--slim my-4" }, {
                                content: _withCtx(() => [
                                  _createVNode("div", _hoisted_24, [
                                    _createVNode("div", _hoisted_25, [
                                      _createVNode("span", _hoisted_26, [
                                        _createVNode(_component_InlineSvgScoped, {
                                          src: 
                                                            require(`@/assets/images/entrancePlants/icon-switchboard.svg`)
                                                        ,
                                          "aria-label": "icon-switchboard"
                                        }, null, 8, ["src"])
                                      ]),
                                      _createVNode("div", _hoisted_27, [
                                        _createVNode("h6", _hoisted_28, _toDisplayString(_ctx.$t("AppResourceEP.Switchboards")), 1)
                                      ])
                                    ]),
                                    (riserInterface.switchboardsCount !== undefined)
                                      ? (_openBlock(), _createBlock(_component_NumberButtons, {
                                          key: 0,
                                          class: "ml-auto",
                                          modelValue: riserInterface.switchboardsCount,
                                          "min-value": 0,
                                          "max-value": 15,
                                          onIncrement: ($event: any) => (riserInterface.switchboardsCount++),
                                          onDecrement: ($event: any) => (riserInterface.switchboardsCount--)
                                        }, null, 8, ["modelValue", "onIncrement", "onDecrement"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          : _createCommentVNode("", true),
                        (key !== (_ctx.currentRiserInterfaces.length - 1))
                          ? (_openBlock(), _createBlock("hr", _hoisted_29))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ])
          ]))
        : (_ctx.step == 1)
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.Gates")), 1),
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  _createVNode(_component_GateConfigComponent, {
                    gatesToConfigure: _ctx.gatesToConfigure,
                    availableScsAddressGate: _ctx.availableScsAddressGate,
                    onAnyScsError: _ctx.updateScsError
                  }, null, 8, ["gatesToConfigure", "availableScsAddressGate", "onAnyScsError"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode("footer", _hoisted_31, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: !_ctx.nextEnabled
      }, null, 8, ["onClick", "label", "disabled"])
    ])
  ], 64))
}